export const CREATE_BOM_DETAILS = "CREATE_BOM_DETAILS";
export const CREATE_BOM_DETAILS_SUCCESS = "CREATE_BOM_DETAILS_SUCCESS";
export const CREATE_BOM_DETAILS_FAILED = "CREATE_BOM_DETAILS_FAILED";

export const UPDATE_BOM_DETAILS = "UPDATE_BOM_DETAILS";
export const UPDATE_BOM_DETAILS_SUCCESS = "UPDATE_BOM_DETAILS_SUCCESS";
export const UPDATE_BOM_DETAILS_FAILED = "UPDATE_BOM_DETAILS_FAILED";

export const GET_BOM_DETAILS = "GET_BOM_DETAILS";
export const GET_BOM_DETAILS_SUCCESS = "GET_BOM_DETAILS_SUCCESS";
export const GET_BOM_DETAILS_FAILED = "GET_BOM_DETAILS_FAILED";

export const GET_BOM_DETAILS_BY_ID = "GET_BOM_DETAILS_BY_ID";
export const GET_BOM_DETAILS_BY_ID_SUCCESS = "GET_BOM_DETAILS_BY_ID_SUCCESS";
export const GET_BOM_DETAILS_BY_ID_FAILED = "GET_BOM_DETAILS_BY_ID_FAILED";

export const GET_ALL_BOM_DETAILS = "GET_ALL_BOM_DETAILS";
export const GET_ALL_BOM_DETAILS_SUCCESS = "GET_ALL_BOM_DETAILS_SUCCESS";
export const GET_ALL_BOM_DETAILS_FAILED = "GET_ALL_BOM_DETAILS_FAILED";

export const DELETE_BOM_DETAILS = "DELETE_BOM_DETAILS";
export const DELETE_BOM_DETAILS_SUCCESS = "DELETE_BOM_DETAILS_SUCCESS";
export const DELETE_BOM_DETAILS_FAILED = "DELETE_BOM_DETAILS_FAILED";

export const DELETE_BILL_OF_MATERIALS = "DELETE_BILL_OF_MATERIALS";
export const DELETE_BILL_OF_MATERIALS_SUCCESS = "DELETE_BILL_OF_MATERIALS_SUCCESS";
export const DELETE_BILL_OF_MATERIALS_FAILED = "DELETE_BILL_OF_MATERIALS_FAILED";

export const EDIT_BILL_OF_MATERIALS = "EDIT_BILL_OF_MATERIALS";
export const EDIT_BILL_OF_MATERIALS_SUCCESS = "EDIT_BILL_OF_MATERIALS_SUCCESS";
export const EDIT_BILL_OF_MATERIALS_FAILED = "EDIT_BILL_OF_MATERIALS_FAILED";

export const GET_ITEMS_BOM_DETAILS = "GET_ITEMS_BOM_DETAILS";
export const GET_ITEMS_BOM_DETAILS_SUCCESS = "GET_ITEMS_BOM_DETAILS_SUCCESS";
export const GET_ITEMS_BOM_DETAILS_FAILED = "GET_ITEMS_BOM_DETAILS_FAILED";

export const DUPLICATE_BOM = "DUPLICATE_BOM";
export const DUPLICATE_BOM_SUCCESS = "DUPLICATE_BOM_SUCCESS";
export const DUPLICATE_BOM_FAILED = "DUPLICATE_BOM_FAILED";

export const BULK_UPLOAD_BOM = "BULK_UPLOAD_BOM";
export const BULK_UPLOAD_BOM_SUCCESS = "BULK_UPLOAD_BOM_SUCCESS";
export const BULK_UPLOAD_BOM_FAILED = "BULK_UPLOAD_BOM_FAILED";